import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppRemixIcon } from '@/layout/AppComponents';
import Select from 'react-select';
import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import colors from '../../../../constants/colors';
import { axiosPath } from '../../../../routing/helpers/router';
import * as currentPageAction from '../../../../store/actions/currentPageAction';
import Translator from '../../../components/helpers/Translator';
import useIsMounted from '../../../components/hooks/useIsMounted';
import ObligationFormQuestionHelp from '../ObligationFormQuestionHelp';
import errorHandler from '../../../components/error/ErrorHandler';
import QuestionChatbot from '../QuestionChatbot';

export default function QuestionType2(props) {
  const { question, isSubquestion } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const userAnswers = useSelector((state) => state.currentPage?.answers);
  const pendingQuestions = useSelector(
    (state) => state.currentPage?.pendingQuestions,
  );
  const permissions = useSelector((state) => state.auth.permissions);
  const [isLoading, setIsLoading] = useState(false);
  const [tempAnswers, setTempAnswers] = useState(
    userAnswers?.[question.id] || [],
  );

  useEffect(() => {
    setTempAnswers(userAnswers?.[question.id] || []);
  }, [question, userAnswers]);

  // > QUESTION CHANGE
  const loadPlantObligationForm = useCallback(async () => {
    setIsLoading(true);
    axios
      .post(
        axiosPath(
          'api_r_user_m_legalCompliance_plantObligationForm_question_change',
        ),
        {
          type: 2,
          moduleBridgeHex,
          plantHex,
          questionID: question.id,
          answerIDs: tempAnswers?.map((a) => a.value) || [],
        },
      )
      .then((r) => {
        if (isMounted.current) {
          dispatch(
            currentPageAction.change('answers', r.data?.userAnswers, true),
          );
          dispatch(
            currentPageAction.change(
              'pendingQuestions',
              r.data.pendingQuestions,
              true,
            ),
          );
          setIsLoading(false);
        }
      })
      .catch((e) => {
        dispatch(errorHandler(e));
      });
  }, [moduleBridgeHex, plantHex, question, tempAnswers]);
  // < QUESTION CHANGE

  return (
    <QuestionGroup>
      <Question $isSubquestion={isSubquestion}>
        <h3>
          {permissions?.client?.gcl?.module?.plant?.userObligationForm
            ?.aiAssistant && <QuestionChatbot question={question} />}
          <AppRemixIcon
            icon="timer-2"
            color={
              pendingQuestions?.includes(question.id)
                ? colors.state2
                : colors.grey200
            }
            filled={pendingQuestions?.includes(question.id)}
            title={
              pendingQuestions?.includes(question.id)
                ? ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="to.be.calculated"
                    />,
                  )
                : ''
            }
            className="mr-1"
          />
          {question.name}
        </h3>
        <Select
          title={question.name}
          placeholder={ReactDOMServer.renderToString(
            <Translator
              file="module-legalCompliance"
              name="scroll.down.see.available.options"
            />,
          )}
          options={question.answers}
          onChange={(v) => setTempAnswers(v)}
          value={tempAnswers}
          isDisabled={isLoading}
          isLoading={isLoading}
          onBlur={() => loadPlantObligationForm()}
          isMulti
          closeMenuOnSelect={false}
        />
      </Question>
      <ObligationFormQuestionHelp question={question} />
    </QuestionGroup>
  );
}

const Question = styled.div`
  margin: 20px 0;
  ${(props) => props.$isSubquestion && 'padding-left: 40px;'}
  h3 {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
`;
const QuestionGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
`;
